import {
  Button,
  type ButtonProps,
  Group,
  NumberInput as MantineNumberInput,
  type NumberInputProps as MantineNumberInputProps,
  type NumberInputHandlers,
  Stack,
} from '@mantine/core';

import { CaretDownIcon, CaretUpIcon } from '@phosphor-icons/react';
import { forwardRef, type HTMLAttributes, useRef } from 'react';

export type NumberInputProps = MantineNumberInputProps;

type InputValueChangeButtonProps = ButtonProps &
  HTMLAttributes<HTMLButtonElement>;

const InputValueChangeButton = ({
  children,
  ...props
}: InputValueChangeButtonProps) => (
  <Button
    color="dark.7"
    h={16}
    p={0}
    radius={6}
    variant="filled"
    w={24}
    {...props}
  >
    {children}
  </Button>
);

export const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
  ({ rightSection, ...props }, ref) => {
    const handlersRef = useRef<NumberInputHandlers>(null);

    return (
      <MantineNumberInput
        decimalScale={2}
        fixedDecimalScale
        flex={1}
        handlersRef={handlersRef}
        ref={ref}
        rightSection={
          <Group gap={4}>
            {rightSection}
            <Stack gap={2} pr={1}>
              <InputValueChangeButton
                data-test-id="increment-button"
                onClick={() => handlersRef.current?.increment()}
              >
                <CaretUpIcon size={14} />
              </InputValueChangeButton>
              <InputValueChangeButton
                data-test-id="decrement-button"
                onClick={() => handlersRef.current?.decrement()}
              >
                <CaretDownIcon size={14} />
              </InputValueChangeButton>
            </Stack>
          </Group>
        }
        rightSectionWidth="auto"
        thousandSeparator=","
        {...props}
      />
    );
  }
);

NumberInput.displayName = 'NumberInput';
